<template>
  <div id="dossierFormulaire">
    <div class="container">
      <div class="step-indicator">
        <p
          v-if="
            this.$store.state.user.role.label != 'eleve' ||
            this.$route.params.personalData === 'true'
          "
          class="step-label"
        >
          Étape {{ etape }}/4
        </p>
        <p
          v-if="
            this.$store.state.user.role.label == 'eleve' &&
            this.$route.params.personalData === 'false'
          "
          class="step-label"
        >
          Étape {{ etape }}/5
        </p>
      </div>

      <template v-if="etape == 1">
        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Nom</label>
            <input
              :value="userData.nom"
              @change="handleChangeNom($event.target.value)"
              type="text"
              id="nom"
              name="nom"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkNom }"
            />
          </div>
          <div class="field-group">
            <label class="field-label">Prénom</label>
            <input
              :value="userData.prenom"
              @change="handleChangePrenom($event.target.value)"
              type="text"
              id="prenom"
              name="prenom"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkPrenom }"
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Téléphone</label>
            <input
              :value="userData.telephone"
              @change="handleChangeTelephone($event.target.value)"
              type="text"
              id="telephone"
              name="telephone"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkTelephone }"
            />
          </div>
          <div class="field-group">
            <label class="field-label">Mail</label>
            <input
              :value="userData.mailEleve"
              type="text"
              id="email"
              name="email"
              class="field-input"
              disabled
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Nom d'usage</label>
            <input
              :value="userData.dossier.nomUsage"
              @change="handleChangeNomUsage($event.target.value)"
              type="text"
              id="nomUsage"
              name="nomUsage"
              class="field-input"
            />
          </div>
          <div class="field-group">
            <label class="field-label">Autres prénoms</label>
            <input
              :value="userData.dossier.autresPrenom"
              @change="handleChangeAutrePrenom($event.target.value)"
              type="text"
              id="autresPrenom"
              name="autresPrenom"
              class="field-input"
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Téléphone parent</label>
            <input
              :value="userData.dossier.telParent"
              @change="handleChangeTelParent($event.target.value)"
              type="text"
              id="telParent"
              name="telParent"
              class="field-input"
            />
          </div>
          <div class="field-group">
            <label class="field-label">Mail parent</label>
            <input
              :value="userData.dossier.mailParent"
              @change="handleChangeMailParent($event.target.value)"
              type="text"
              id="mailParent"
              name="mailParent"
              class="field-input"
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group field-full">
            <label class="field-label">Adresse</label>
            <input
              :value="userData.dossier.adresse"
              @change="handleChangeAdresse($event.target.value)"
              type="text"
              id="adresse"
              name="adresse"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkAdresse }"
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Code postal</label>
            <input
              :value="userData.dossier.codePostal"
              @change="handleChangeCodePostal($event.target.value)"
              type="text"
              id="codePostal"
              name="codePostal"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkCodePostal }"
            />
          </div>
          <div class="field-group">
            <label class="field-label">Ville</label>
            <input
              :value="userData.dossier.ville"
              @change="handleChangeVille($event.target.value)"
              type="text"
              id="ville"
              name="ville"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkVille }"
            />
          </div>
        </div>
      </template>

      <template v-if="etape == 2">
        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Date de naissance</label>
            <input
              :value="dateNaissanceFormated"
              @change="handleChangeDateNaissance($event.target.value)"
              type="date"
              id="dateNaissance"
              name="dateNaissance"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkDateNaissance }"
            />
          </div>
          <div class="field-group">
            <label class="field-label">Pays de naissance</label>
            <input
              :value="userData.dossier.paysNaissance"
              @change="handleChangePaysNaissance($event.target.value)"
              type="text"
              id="paysNaissance"
              name="paysNaissance"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkPaysNaissance }"
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Ville de naissance</label>
            <input
              :value="userData.dossier.villeNaissance"
              @change="handleChangeVilleNaissance($event.target.value)"
              type="text"
              id="villeNaissance"
              name="villeNaissance"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkVilleNaissance }"
            />
          </div>
          <div class="field-group">
            <label class="field-label">Département de naissance</label>
            <input
              :value="userData.dossier.depNaissance"
              @change="handleChangeDepNaissance($event.target.value)"
              type="text"
              id="depNaissance"
              name="depNaissance"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkDepNaissance }"
            />
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Nationalité française</label>
            <select
              :value="userData.dossier.nationaliteFR"
              @change="handleChangeNationaliteFR($event.target.value)"
              id="nationaliteFR"
              name="nationaliteFR"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkNationaliteFR }"
            >
              <option value="null" disabled selected>
                Nationalité française
              </option>
              <option :value="true">OUI</option>
              <option :value="false">NON</option>
            </select>
          </div>
          <div class="field-group">
            <label class="field-label">Parlez-vous français couramment ?</label>
            <select
              :value="userData.dossier.parlerFRCouramment"
              @change="handleChangeParlerFRCouramment($event.target.value)"
              id="parlerFRCouramment"
              name="parlerFRCouramment"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkParlerFRCouramment }"
            >
              <option value="null" disabled>
                Parlez-vous français couramment ?
              </option>
              <option :value="true">OUI</option>
              <option :value="false">NON</option>
            </select>
          </div>
        </div>
      </template>

      <template v-if="etape == 3">
        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Catégorie de permis demandée</label>
            <select
              :value="userData.dossier.permis"
              @change="handleChangePermis($event.target.value)"
              id="permis"
              name="permis"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkPermis }"
            >
              <option value="null" disabled>
                Catégorie de permis demandée
              </option>
              <option
                v-for="(item, index) in permis"
                :value="'/api/permis/' + item.id"
                :key="index"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
          <div class="field-group">
            <label class="field-label">Portez-vous des lunettes ?</label>
            <select
              :value="userData.dossier.lunettes"
              @change="handleChangeLunettes($event.target.value)"
              id="lunettes"
              name="lunettes"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkLunettes }"
            >
              <option value="null" disabled>Portez-vous des lunettes ?</option>
              <option :value="true">OUI</option>
              <option :value="false">NON</option>
            </select>
          </div>
        </div>

        <div class="field-row">
          <div class="field-group">
            <label class="field-label">Besoin d'un véhicule aménagé ?</label>
            <select
              :value="userData.dossier.vehiculeAmenage"
              @change="handleChangeVehiculeAmenage($event.target.value)"
              id="vehiculeAmenage"
              name="vehiculeAmenage"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkVehiculeAmenage }"
            >
              <option value="null" disabled>
                Avez-vous besoin d'un véhicule aménagé ?
              </option>
              <option :value="true">OUI</option>
              <option :value="false">NON</option>
            </select>
          </div>
          <div class="field-group">
            <label class="field-label">Conduite accompagnée prévue ?</label>
            <select
              :value="userData.dossier.prevoitAac"
              @change="handleChangePrevoitAac($event.target.value)"
              id="prevoitAac"
              name="prevoitAac"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkPrevoitAac }"
            >
              <option value="null" disabled>
                Prévoyez-vous une conduite accompagnée ?
              </option>
              <option :value="true">OUI</option>
              <option :value="false">NON</option>
            </select>
          </div>
        </div>

        <div class="field-row">
          <div class="field-group field-full">
            <label class="field-label">Fait suite à une annulation / invalidation de permis ?</label>
            <select
              :value="userData.dossier.faitSuite"
              @change="handleChangeFaitSuite($event.target.value)"
              id="faitSuite"
              name="faitSuite"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkFaitSuite }"
            >
              <option value="null" disabled>
                La présente demande fait-elle suite à une annulation /
                invalidation de permis ?
              </option>
              <option :value="true">OUI</option>
              <option :value="false">NON</option>
            </select>
          </div>
        </div>

        <div
          class="field-row"
          :class="{
            isHide: !(
              userData.dossier.faitSuite === 'true' ||
              userData.dossier.faitSuite === true
            ),
          }"
        >
          <div class="field-group field-full">
            <label class="field-label">En raison d'une conduite sous alcoolémie ou stupéfiant ?</label>
            <select
              :value="userData.dossier.motifAlcoolStup"
              @change="handleChangeMotifAlcoolStup($event.target.value)"
              id="motifAlcoolStup"
              name="motifAlcoolStup"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkMotifAlcoolStup }"
            >
              <option value="null" disabled>
                En raison d'une conduite sous alcoolémie ou stupéfiant ?
              </option>
              <option :value="true">OUI</option>
              <option :value="false">NON</option>
            </select>
          </div>
        </div>
      </template>

      <template v-if="etape == 4">
        <div class="field-row">
          <div class="field-group field-full">
            <label class="field-label">Statut social</label>
            <select
              :value="userData.dossier.social"
              @change="handleChangeSocial($event.target.value)"
              id="social"
              name="social"
              class="field-input"
              :class="{ 'field-invalid': showValidation && !checkSocial }"
            >
              <option value="null" disabled>Statut social</option>
              <option
                v-for="(item, index) in statutSocial"
                :value="'/api/statut_socials/' + item.id"
                :key="index"
              >
                {{ item.label }}
              </option>
            </select>
          </div>
        </div>

        <div class="field-row" :class="{ isHide: !isSalarie }">
          <div class="field-group field-full">
            <label class="field-label">Métier</label>
            <input
              :value="userData.dossier.metier"
              @change="handleChangeMetier($event.target.value)"
              type="text"
              id="metier"
              name="metier"
              class="field-input"
            />
          </div>
        </div>

        <div class="field-row" :class="{ isHide: !isLyceen }">
          <div class="field-group field-full">
            <label class="field-label">Lycée</label>
            <select
              :value="userData.dossier.lycee"
              @change="handleChangeLycee($event.target.value)"
              id="lycee"
              name="lycee"
              class="field-input"
            >
              <option value="null">Autre</option>
              <option
                v-for="(item, index) in lycees"
                :value="'/api/lycees/' + item.id"
                :key="index"
              >
                {{ item.nom }}
              </option>
            </select>
          </div>
        </div>

        <div class="field-row" :class="{ isHide: !isAutreLycee }">
          <div class="field-group field-full">
            <label class="field-label">Autre lycée</label>
            <input
              :value="userData.dossier.autreLycee"
              @change="handleChangeAutreLycee($event.target.value)"
              type="text"
              id="autreLycee"
              name="autreLycee"
              class="field-input"
            />
          </div>
        </div>

        <div
          class="field-row"
          v-if="
            etape == 4 &&
            (this.$store.state.user.role.label != 'eleve' ||
              this.$route.params.personalData === 'true')
          "
        >
          <div class="field-group field-full">
            <label class="field-label">Numéro NEPH</label>
            <input
              :value="userData.dossier.numNeph"
              @change="handleChangeNumNeph($event.target.value)"
              type="text"
              id="numNeph"
              name="numNeph"
              class="field-input"
            />
          </div>
        </div>
      </template>

      <template
        v-if="
          etape == 5 &&
          this.$store.state.user.role.label == 'eleve' &&
          this.$route.params.personalData === 'false'
        "
      >
        <p class="step-question">Avez-vous un numéro NEPH ?</p>
        <div class="neph-toggle">
          <button
            type="button"
            class="btn-toggle"
            :class="{ active: numNephR === true }"
            @click="numNephQ(true)"
          >
            OUI
          </button>
          <button
            type="button"
            class="btn-toggle"
            :class="{ active: numNephR === false }"
            @click="numNephQ(false)"
          >
            NON
          </button>
        </div>

        <div :class="{ isHide: numNephR === false || numNephR === null }">
          <div class="field-row">
            <div class="field-group field-full">
              <label class="field-label">Si vous avez déjà un numéro NEPH, merci de le saisir ici</label>
              <input
                :value="userData.dossier.numNeph"
                @change="handleChangeNumNeph($event.target.value)"
                type="text"
                id="numNeph"
                name="numNeph"
                class="field-input"
                placeholder="NEPH"
              />
            </div>
          </div>
          <div class="form-actions">
            <button
              v-if="!isWorking"
              type="button"
              class="btn btn-primary"
              @click="saveDossier('neph')"
            >
              Enregistrer
            </button>
            <button v-else type="button" class="btn btn-primary" disabled>
              <i class="fa fa-spinner fa-spin"></i> Enregistrer
            </button>
          </div>
        </div>

        <div :class="{ isHide: numNephR === true || numNephR === null }" class="payment-block">
          <p class="payment-amount">Montant : {{ filterFonctionnalite.montant }}€</p>
          <p class="payment-sub">Vous avez la possibilité de régler de 3 manières possibles :</p>
          <BoutonPaiement @paiement="saveDossier($event)"></BoutonPaiement>
        </div>
      </template>

      <div class="form-actions">
        <template v-if="etape == 1 && this.$store.state.user.role.label == 'eleve'">
          <button type="button" id="btnRetourVueMobile" class="btn btn-secondary" @click="$emit('ordreVueMobile')">
            Retour
          </button>
        </template>
        <template v-if="etape != 1">
          <button type="button" class="btn btn-secondary" @click="retourEtape">
            Retour
          </button>
        </template>

        <template
          v-if="
            etape <= 4 &&
            (this.$store.state.user.role.label != 'eleve' ||
              this.$route.params.personalData === 'true')
          "
        >
          <button v-if="!isWorking" type="button" class="btn btn-primary" @click="saveDossier('admin')">
            Enregistrer
          </button>
          <button v-else type="button" class="btn btn-primary" disabled>
            <i class="fa fa-spinner fa-spin"></i> Enregistrer
          </button>
        </template>

        <template
          v-if="
            etape < 4 ||
            (etape == 4 &&
              this.$store.state.user.role.label == 'eleve' &&
              this.$route.params.personalData === 'false')
          "
        >
          <button type="button" class="btn btn-primary" @click="suivantEtape">
            Suivant
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import BoutonPaiement from "@/components/eleve/BoutonPaiement.vue";

export default {
  name: "Formulaire",
  props: {
    userData: { type: Object },
    showValidation: { type: Boolean },
    isWorking: { type: Boolean },
  },
  components: {
    BoutonPaiement,
  },
  data() {
    return {
      numNephR: null,
      etape: 1,
    };
  },
  mounted() {
    this.getFonctionnalite();
  },
  methods: {
    ...mapActions(["getFonctionnalite"]),

    numNephQ(rep) {
      // Récupère la reponse de l'utilisateur pour le numNEPH
      this.numNephR = rep;
    },

    suivantEtape() {
      // Passe à l'étape suivante
      if (this.etape < 5) {
        this.etape++;
      }
    },

    retourEtape() {
      // Passe à l'étape précédente
      if (this.etape > 1) {
        this.etape--;
      }
    },

    //
    // Les handleChange servent à l'update des infos du template parent
    //

    handleChangeNom(data) {
      let userDataTmp = this.userData;
      userDataTmp.nom = data;
      this.handleChange(userDataTmp);
    },

    handleChangePrenom(data) {
      let userDataTmp = this.userData;
      userDataTmp.prenom = data;
      this.handleChange(userDataTmp);
    },

    handleChangeTelephone(data) {
      let userDataTmp = this.userData;
      userDataTmp.telephone = data;
      this.handleChange(userDataTmp);
    },

    handleChangeNomUsage(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.nomUsage = data;
      this.handleChange(userDataTmp);
    },

    handleChangeAutrePrenom(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.autresPrenom = data;
      this.handleChange(userDataTmp);
    },

    handleChangeTelParent(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.telParent = data;
      this.handleChange(userDataTmp);
    },

    handleChangeMailParent(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.mailParent = data;
      this.handleChange(userDataTmp);
    },

    handleChangeAdresse(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.adresse = data;
      this.handleChange(userDataTmp);
    },

    handleChangeCodePostal(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.codePostal = data;
      this.handleChange(userDataTmp);
    },

    handleChangeVille(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.ville = data;
      this.handleChange(userDataTmp);
    },

    handleChangeDateNaissance(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.dateNaissance = data;
      this.handleChange(userDataTmp);
    },

    handleChangePaysNaissance(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.paysNaissance = data;
      this.handleChange(userDataTmp);
    },

    handleChangeVilleNaissance(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.villeNaissance = data;
      this.handleChange(userDataTmp);
    },

    handleChangeDepNaissance(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.depNaissance = data;
      this.handleChange(userDataTmp);
    },

    handleChangeNationaliteFR(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.nationaliteFR = data;
      this.handleChange(userDataTmp);
    },

    handleChangeParlerFRCouramment(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.parlerFRCouramment = data;
      this.handleChange(userDataTmp);
    },

    handleChangePermis(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.permis = data;
      this.handleChange(userDataTmp);
    },

    handleChangeLunettes(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.lunettes = data;
      this.handleChange(userDataTmp);
    },

    handleChangeVehiculeAmenage(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.vehiculeAmenage = data;
      this.handleChange(userDataTmp);
    },

    handleChangePrevoitAac(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.prevoitAac = data;
      this.handleChange(userDataTmp);
    },

    handleChangeFaitSuite(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.faitSuite = data;
      this.handleChange(userDataTmp);
    },

    handleChangeMotifAlcoolStup(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.motifAlcoolStup = data;
      this.handleChange(userDataTmp);
    },

    handleChangeSocial(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.social = data;
      this.handleChange(userDataTmp);
    },

    handleChangeMetier(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.metier = data;
      this.handleChange(userDataTmp);
    },

    handleChangeLycee(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.lycee = data;
      this.handleChange(userDataTmp);
    },

    handleChangeAutreLycee(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.autreLycee = data;
      this.handleChange(userDataTmp);
    },

    handleChangeNumNeph(data) {
      let userDataTmp = this.userData;
      userDataTmp.dossier.numNeph = data;
      this.handleChange(userDataTmp);
    },

    handleChange(userDataUpdated) {
      // Envoie l'update du formulaire
      this.$emit("update", userDataUpdated);
    },

    saveDossier(mode) {
      // Envoie l'update du checkAll
      this.$emit("updateCheckAll", this.checkAll);
      // Lance la sauvegarde du dossier
      this.$emit("saveDossier", mode);
    },
  },
  computed: {
    ...mapGetters(["permis", "statutSocial", "lycees", "fonctionnalite"]),

    checkAll() {
      return (
        this.checkNom &&
        this.checkPrenom &&
        this.checkTelephone &&
        this.checkAdresse &&
        this.checkCodePostal &&
        this.checkVille &&
        this.checkDateNaissance &&
        this.checkPaysNaissance &&
        this.checkDepNaissance &&
        this.checkVilleNaissance &&
        this.checkNationaliteFR &&
        this.checkParlerFRCouramment &&
        this.checkVehiculeAmenage &&
        this.checkLunettes &&
        this.checkPermis &&
        this.checkFaitSuite &&
        this.checkPrevoitAac &&
        this.checkSocial &&
        this.fonctionnalite !== null
      );
    },
    dateNaissanceFormated() {
      // Si le format de la date est "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"
      // Quand la date provient de la base de donnée
      if (this.userData.dossier.dateNaissance.match(/.+[T ]/g) !== null) {
        // Alors conversion en format "yyyy-MM-dd"
        return this.userData.dossier.dateNaissance
          .match(/.+[T ]/g)[0]
          .substring(
            0,
            this.userData.dossier.dateNaissance.match(/.+[T ]/g)[0].length - 1
          );
      }
      // Sinon la date reste comme elle est
      return this.userData.dossier.dateNaissance;
    },
    checkNom() {
      const match = this.userData.nom.match(
        /[A-Za-zàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{1,250}/g
      );
      if (match !== null && match.length === 1) {
        return this.userData.nom === match[0];
      }
      return false;
    },
    checkPrenom() {
      const match = this.userData.prenom.match(
        /[A-Za-zàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{1,250}/g
      );
      if (match !== null && match.length === 1) {
        return this.userData.prenom === match[0];
      }
      return false;
    },
    checkTelephone() {
      // Match le numéro de téléphone français
      const match = this.userData.telephone.match(
        /[0-9]{10}/g
      );
      // Si le numéro de téléphone a un match
      if (match !== null && match.length === 1) {
        // true quand le match est exactement égal au numéro de téléphone
        return this.userData.telephone === match[0];
      }
      return false;
    },
    checkAdresse() {
      return this.userData.dossier.adresse !== "";
    },
    checkCodePostal() {
      // Match les code postaux français (5) ou belge (4)
      const match = this.userData.dossier.codePostal.match(
        /[0-9]{5}|[1-9]{1}[0-9]{3}/g
      );
      // Si le code postal a un match
      if (match !== null && match.length === 1) {
        // true quand le match est exactement égal au code postal
        return this.userData.dossier.codePostal === match[0];
      }
      return false;
    },
    checkVille() {
      return this.userData.dossier.ville !== "";
    },
    checkDateNaissance() {
      return this.userData.dossier.dateNaissance !== "";
    },
    checkPaysNaissance() {
      return this.userData.dossier.paysNaissance !== "";
    },
    checkDepNaissance() {
      return this.userData.dossier.depNaissance !== "";
    },
    checkVilleNaissance() {
      return this.userData.dossier.villeNaissance !== "";
    },
    checkNationaliteFR() {
      return this.userData.dossier.nationaliteFR !== "null";
    },
    checkParlerFRCouramment() {
      return this.userData.dossier.parlerFRCouramment !== "null";
    },
    checkVehiculeAmenage() {
      return this.userData.dossier.vehiculeAmenage !== "null";
    },
    checkLunettes() {
      return this.userData.dossier.lunettes !== "null";
    },
    checkPermis() {
      return this.userData.dossier.permis !== "null";
    },
    checkFaitSuite() {
      return this.userData.dossier.faitSuite !== "null";
    },
    checkMotifAlcoolStup() {
      return this.userData.dossier.motifAlcoolStup !== "null";
    },
    checkPrevoitAac() {
      return this.userData.dossier.prevoitAac !== "null";
    },
    checkSocial() {
      return this.userData.dossier.social !== "null";
    },
    isSalarie() {
      // Si le statut social à été chargé
      if (this.checkSocial && this.statutSocial !== null) {
        // Boucle les statuts sociaux
        for (let i = 0; i < this.statutSocial.length; i++) {
          // Si le statut est "Salarié"
          if (this.statutSocial[i].label === "Salarié") {
            // retourne si le statut séléctionné est le statut "Salarié"
            return (
              "/api/statut_socials/" + this.statutSocial[i].id ===
              this.userData.dossier.social
            );
          }
        }
      }
      return false;
    },
    isLyceen() {
      // Si le statut social à été chargé
      if (this.checkSocial && this.statutSocial !== null) {
        // Boucle les statuts sociaux
        for (let i = 0; i < this.statutSocial.length; i++) {
          // Si le statut est "Lycéen"
          if (this.statutSocial[i].label === "Lycéen") {
            // retourne si le statut séléctionné est le statut "Lycéen"
            return (
              "/api/statut_socials/" + this.statutSocial[i].id ===
              this.userData.dossier.social
            );
          }
        }
      }
      return false;
    },
    isAutreLycee() {
      // Si le statut social séléctionné est le statut "Lycéen" et que le lycée séléctionné est "Autre Lycée"
      return this.isLyceen && this.userData.dossier.lycee === "null";
    },
    filterFonctionnalite() {
      // Si les fonctionnalités ont été téléchargés
      if (this.fonctionnalite !== null) {
        // Filtre puis retourne la fonctionnalité "dossier"
        return this.fonctionnalite.filter((el) => el.label === "dossier")[0];
      }
      // Sinon, retourne un objet avec un montant vide pour évité les erreurs lors du chargement des fonctionnalités
      return {
        montant: "",
      };
    },
  },
};
</script>

<style scoped>
#dossierFormulaire {
  text-align: left;
}

div.container {
  padding: 24px 28px;
}

.isHide {
  display: none;
}

.step-indicator {
  margin-bottom: 20px;
}

.step-label {
  display: inline-block;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #3b82f6;
  background: #eff6ff;
  padding: 6px 14px;
  border-radius: 20px;
  margin: 0;
}

.field-row {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.field-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  flex: 1;
  min-width: 0;
}

.field-full {
  flex: 1 1 100%;
}

.field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}

.field-input {
  width: 100%;
  box-sizing: border-box;
  padding: 9px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  color: #1e293b;
  background: #f8fafc;
  outline: none;
  font-family: inherit;
  transition: border-color 0.18s, background 0.18s;
}

.field-input:focus {
  border-color: #3b82f6;
  background: #ffffff;
}

.field-input:disabled {
  color: #94a3b8;
  cursor: not-allowed;
}

.field-invalid {
  border-color: #ef4444 !important;
}

.step-question {
  font-size: 14px;
  font-weight: 600;
  color: #1a1f2e;
  margin: 0 0 12px;
}

.neph-toggle {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.btn-toggle {
  flex: 1;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
  color: #64748b;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.18s;
}

.btn-toggle:hover {
  border-color: #3b82f6;
  color: #3b82f6;
}

.btn-toggle.active {
  background: #3b82f6;
  border-color: #3b82f6;
  color: #ffffff;
}

.payment-block {
  margin-top: 8px;
}

.payment-amount {
  font-size: 16px;
  font-weight: 700;
  color: #1a1f2e;
  margin: 0 0 4px;
}

.payment-sub {
  font-size: 13px;
  color: #64748b;
  margin: 0 0 16px;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 12px;
}

.btn {
  flex: 1;
  padding: 10px 18px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.18s, opacity 0.18s;
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-primary {
  background: #3b82f6;
  color: #ffffff;
}

.btn-primary:hover:not(:disabled) {
  background: #2563eb;
}

.btn-secondary {
  background: #f1f5f9;
  color: #475569;
}

.btn-secondary:hover:not(:disabled) {
  background: #e2e8f0;
}

/* Desktop Styles */
@media only screen and (min-width: 961px) {
  #btnRetourVueMobile {
    display: none;
  }
}

/* Mobile / tablet */
@media only screen and (max-width: 960px) {
  .field-row {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
